import { render } from "./ResourceReader.vue?vue&type=template&id=9dd01d36&scoped=true"
import script from "./ResourceReader.vue?vue&type=script&lang=js"
export * from "./ResourceReader.vue?vue&type=script&lang=js"

import "./ResourceReader.vue?vue&type=style&index=0&id=9dd01d36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd01d36"]])

export default __exports__